import PropTypes from "prop-types";
import React from "react";
import Truncate from "src/components/truncate";
import cx from "classnames";

import { NavLink } from "react-router-dom";

import { Row, Col, Image, Card } from "react-bootstrap";
import TimeAgo from "react-timeago";
import Lottie from "lottie-react-web";
import buildUrl from "build-url-ts";
import _ from "lodash";

import wave from "src/legacy/components/sideMenu/animatedIcons/wave.json";
import Tooltip from "src/components/tooltip";
import { localizedStrings } from "src/localization/index.jsx";

import styles from "./styles.module.scss";

class ChatUserRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animationData: "",
    };

    this.handleChatUserClick = this.handleChatUserClick.bind(this);

    this.localizedEngage = localizedStrings.pages.engage;
  }

  componentDidMount() {
    fetch(wave)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          loading: false,
          animationData: data,
        });
      });
  }

  renderName() {
    return `${this.props.chatUser.firstName || ""} ${this.props.chatUser.lastName || ""}`;
  }

  renderCountry() {
    var country = this.props.chatUser.country;
    if (country != null) {
      var city = country && country.city ? `${country && country.city},` : "";
      return `${city} ${(country && country.country_name) || "NA"}`;
    } else {
      return "NA";
    }
  }

  renderInitials() {
    let initial;

    if (this.props.chatUser.type == "visitor") {
      return <span className="paperflite-user-settings" />;
    }

    let firstName = "";
    let lastName = "";
    if (_.get(this.props.chatUser, "firstName") != null) {
      firstName = _.get(this.props.chatUser, "firstName").charAt(0);
    }

    if (_.get(this.props.chatUser, "lastName") != null) {
      lastName = _.get(this.props.chatUser, "lastName").charAt(0);
    }

    initial = firstName + lastName;

    return initial.toUpperCase();
  }

  handleChatUserClick(chatUserId) {
    // this.props.trackAdoptionMetricsForRecipientSelectedEvent();
    if (this.props.activeChatUser) {
      this.props.activeChatUser(chatUserId);
    }
  }

  render() {
    return (
      <div>
        {this.props.detailView
          ? this._wrapChatUserWithLink(this.renderDetailedChatUser())
          : this._wrapChatUserWithLink(this.renderChatUser())}
      </div>
    );
  }

  _wrapChatUserWithLink(chatUser) {
    var indexLetter = "#";

    if (this.props.chatUser && this.props.chatUser.firstName) {
      indexLetter = this.props.chatUser.firstName.charAt(0).toUpperCase();
      if (!indexLetter.match(/[a-z]/i)) {
        indexLetter = "#";
      }
    }

    var url = buildUrl(`/engage/${this.props.chatUser.id}`, {
      queryParams: {
        filter: this.props.filter,
        global: this.props.global,
      },
    });

    return (
      <NavLink
        to={url}
        className={({ isActive }) =>
          cx(styles.chatUser, {
            [styles.active]: isActive,
            [styles.detailedChatUser]: this.props.detailView,
          })
        }
        data-index={indexLetter}
      >
        {chatUser}
      </NavLink>
    );
  }

  renderOnlineStatus(chatUser) {
    return <TimeAgo date={chatUser.lastOnline} live={false} />;
  }

  renderTimeSpent() {
    const timeSpent = this.props.chatUser.timeSpent || 0;
    let timeSpentValue = this.padNumber(timeSpent);

    return timeSpentValue;
  }

  padNumber(seconds) {
    seconds = Number(seconds);
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor((seconds % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
    var sDisplay = "";
    if (h <= 0) {
      sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
    }

    return hDisplay + mDisplay + sDisplay;
  }

  renderDetailedChatUser() {
    return (
      <Row>
        <Col sm={3}>
          <Card
            key={this.props.chatUser.id}
            className={cx(styles.inner, styles.noBorderCard, {
              [styles.disabled]: this.props.disabled,
            })}
            onClick={() => this.handleChatUserClick(this.props.chatUser.id)}
          >
            <Card.Body className={styles.body}>
              <div className={cx(styles.left, styles.detailedLeft)}>
                <div className={styles.iconContainer}>
                  {this.props.chatUser.online && (
                    <div className={styles.online}></div>
                  )}
                  {!this.props.icon && (
                    <div className={styles.chatUserAvatar}>
                      {" "}
                      {this.renderInitials()}{" "}
                    </div>
                  )}
                  {this.props.icon && (
                    <Image
                      className={styles.chatUserIcon}
                      src={this.props.icon.thumbnail}
                      circle
                    />
                  )}
                </div>
              </div>
              <div className={styles.bodyInner}>
              <Tooltip content={this.renderName(this.props.chatUser)} placement="top">
                <div className={styles.chatUserNames}>
                  <Truncate lines={1} width={200}>
                    {" "}
                    {this.renderName(this.props.chatUser)}{" "}
                  </Truncate>
                </div>
              </Tooltip>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={3} className={styles.companyName}>
          {this.props.chatUser.contactDTO ? (
            <p>{this.props.chatUser.contactDTO.company}</p>
          ) : (
            <p>-</p>
          )}
        </Col>
        <Col sm={2}>
          <div className={styles.chatUserDetails}>
            {this.props.chatUser.online
              ? this.localizedEngage.viewers.live_now
              : ""}
            {!this.props.chatUser.online &&
              this.renderOnlineStatus(this.props.chatUser)}
          </div>
        </Col>
        <Col sm={3}>
          <div className={styles.chatUserDetails}>{this.renderCountry()}</div>
        </Col>
      </Row>
    );
  }

  renderChatUser() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: wave,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div
        key={this.props.chatUser.id}
        className={cx(styles.chatUserInner, {
          [styles.disabled]: this.props.disabled,
        })}
        onClick={() => this.handleChatUserClick(this.props.chatUser.id)}
      >
        <div className={cx(styles.chatUserleft)}>
          {this.props.chatUser.online && (
            <div className={styles.liveIcon}>
              <Lottie
                options={defaultOptions}
                height={25}
                width={25}
                isStopped={false}
              />
            </div>
          )}

          <div className={cx(styles.userIconContainer)}>
            {this.props.chatUser.online && (
              <div className={styles.online}></div>
            )}
            {!this.props.icon && (
              <div className={styles.chatUserAvatars}>
                {this.renderInitials()}
              </div>
            )}
            {this.props.icon && (
              <Image
                className={styles.chatUserIcon}
                src={this.props.icon.thumbnail}
                circle
              />
            )}
          </div>
        </div>

        <div className={cx(styles.userChatBody, styles.userSeparator)}>
          <div className={cx(styles.userBodyInner, styles.flexColumn)}>
          <Tooltip content={this.renderName(this.props.chatUser)} placement="top">
            <div className={styles.chatUserName}>
              <Truncate lines={1}>
                {this.renderName(this.props.chatUser)}
              </Truncate>
            </div>
          </Tooltip>
            <div className={cx(styles.chatUserPresence)}>
              {this.props.chatUser.online
                ? this.localizedEngage.chat_view.viewers_card.online
                : this.localizedEngage.chat_view.viewers_card.last_online}{" "}
              {!this.props.chatUser.online &&
                this.renderOnlineStatus(this.props.chatUser)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ChatUserRow;
